import React from "react";
import { MapPin, Phone, Mail, Clock, Accessibility, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
export default function NosBureauxALyon() {
  return;
}